import { Box, FormControl, FormControlLabel } from "@mui/material"
import { ReactSelect } from "components/AdvanceDropdown/NormalDropdown/Dropdown"
import { PhoneNumberDropdown } from "components/AdvanceDropdown/PhoneNumberDropdown/Dropdown"
import { CustomLabel, CustomRadioGroup } from "components/Contact/styled-components"
import { CheckBox } from "components/FormComponent/CheckBox"
import { CustomRadio } from "components/FormComponent/Radio"
import { SelectDate } from "components/FormComponent/SelectDate"
import { CustomPlaceHolderInputField } from "components/FormComponent/TextField"
import { Controller } from "react-hook-form"

export const TextField = ({ name, label, placeholder, required, control, errors }) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      rules={{
        required: required ? "This field is required" : false,
        validate: (value) => value.trim() !== "" || "Cannot be empty",
      }}
      render={({ field }) => (
        <CustomPlaceHolderInputField
          field={field}
          error={errors[name]}
          helperText="Indtast venligst et gyldigt fornavn"
          label={label}
          placeholder={placeholder}
        />
      )}
    />
  )
}

export const EmailField = ({ name, label, placeholder, required, control, errors }) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      rules={{
        required: required ? "Email is required" : false,
        validate: (value) => {
          const trimmed = value.trim();
          if (!trimmed) return "Email is required";
          const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          return pattern.test(trimmed) || "Invalid email";
        }
      }}
      render={({ field }) => (
        <CustomPlaceHolderInputField
          field={field}
          error={errors[name]}
          helperText="Indtast venligst en gyldig e-mailadresse"
          label={label}
          placeholder={placeholder}
        />
      )}
    />
  )
}


export const PhoneField = ({ name, label, placeholder, required, errors, register, testLeadData, control  }) => {
  
    return <PhoneNumberDropdown error={errors.country_id || errors.phone ? true : false} helperText={"Indtast venligst et gyldigt telefonnummer"} options={testLeadData?.D?.countries} control={control} getPhoneId={'country_id'} getPhoneNumber={'phone'} placeholder={ 'Land' } description={"Søg landekode"} />
}


export const DateOfBirthField = ({ name, label, required, control, watch, getValues, setValue, register  }) => {
    return  <SelectDate setValue={setValue} getValues={getValues} watch={watch} control={control} dateOfBirth={'dateOfBirth'} />
}

export const CommentField = ({ name, label, required, errors, register  }) => {
    return <FormControl
                        sx={{ mb: 2, gap: '8px' }}
                        fullWidth
                        variant='filled'
                      >
                        <CustomLabel shrink  className="h5">
                          {label}{required && <>&nbsp;<span>*</span></>}
                        </CustomLabel>
                           <CustomInput
                            placeholder={ buttonsLabel?.filter( btn => btn.UILabelProperty === 'commentPlaceholder')[0]?.Label }
                            multiline
                            rows={4}
                            {...register('kommentar')}
                          />
                      </FormControl>
}

export const SelectField = ({ name, options, control, placeholder, required }) => {
 
  return <Controller
            control={control}
            name={name}
            rules={{
              required,
            }}
            render={({ field: { onChange, value, ref, error } }) => {
              return (
                <ReactSelect
                sx={{ maxWidth: '300px', width: '100%' }}
                    error={error}
                    helperText={'select valid option'}
                    placeholder={placeholder}
                    inputRef={ref}
                    options={options.map((op) => ({
                      value: op,
                      label: op,
                    }))}
                    value={value}
                    onChange={(e) => {
                      onChange(e);
                    }}
                />
            )
            }}
        />
} 

export const RadioField = ({ name, label, required, placeholder, control, watch, getValues, setValue, register  }) => {
    return <CustomRadio label={placeholder} register={{...register(name, { required: true })}} value={label} />
}

export const CheckboxField = ({ name, label, required, placeholder, control, watch, getValues, setValue, register  }) => {
    return <Box sx={{ display: 'flex', alignItems: 'center', color: '#000', lineHeight: '1.3' }}>
      <CheckBox label={placeholder} register={{...register(name, { required: false })}} value={label} />
      <p className="paragraph2-light">{placeholder}</p>
      </Box>
}
